import React from "react";
import ServiceTemplate from "../../components/templates/ServiceTemplate";
import autoBg from "../../assets/images/produtos/auto.webp";

const AutoInsurance = () => {
  const serviceData = {
    heroImage: autoBg,
    title: "Seguro Auto",
    subtitle: "Proteção completa para seu veículo com as melhores coberturas",
    color: "blue",
    icon: "car",
    ramo: "Auto",
    pageRamo: true,
    showEmail: false,
    showVeiculo: true,
    formUrl: "https://docs.google.com/forms/d/e/1FAIpQLScQc-SPygWVNQn0Zl1IUIqvtMl73Xa1sa_6qW7IaBalG3J5Ug/formResponse",
    mainContent: [
      "O seguro auto é essencial para proteger seu veículo contra diversos riscos, como roubo, furto, colisão, incêndio e danos causados a terceiros. Com um seguro auto da Free Market Seguros, você dirige com tranquilidade sabendo que está protegido em qualquer situação.",
      "Trabalhamos com as principais seguradoras do mercado para oferecer a você as melhores coberturas com preços competitivos, garantindo o melhor custo-benefício para seu perfil."
    ],
    coverages: [
      "Colisão, incêndio, roubo e furto",
      "Danos materiais a terceiros",
      "Danos corporais a terceiros",
      "Assistência 24 horas",
      "Carro reserva"
    ],
    additionalCoverages: [
      "Vidros, faróis, lanternas e retrovisores",
      "Acessórios e equipamentos",
      "Proteção contra eventos da natureza",
      "Proteção contra pequenos reparos",
      "Extensão de perímetro para países vizinhos"
    ],
    advantages: [
      {
        icon: "shield-alt",
        title: "Proteção Completa",
        description: "Cobertura abrangente para seu veículo e para danos a terceiros"
      },
      {
        icon: "headset",
        title: "Assistência 24h",
        description: "Suporte em qualquer lugar e a qualquer hora para emergências"
      },
      {
        icon: "hand-holding-usd",
        title: "Melhor Custo-Benefício",
        description: "Comparamos preços entre várias seguradoras para você"
      }
    ],
    steps: [
      {
        title: "Solicite uma Cotação",
        description: "Preencha nosso formulário com seus dados e informações do veículo para receber uma cotação personalizada."
      },
      {
        title: "Compare as Opções",
        description: "Nossos consultores apresentarão as melhores opções de seguradoras e coberturas para seu perfil."
      },
      {
        title: "Contrate com Facilidade",
        description: "Após escolher a melhor opção, finalize a contratação de forma simples e rápida, com pagamento facilitado."
      },
      {
        title: "Suporte Contínuo",
        description: "Conte com nossa equipe para qualquer necessidade durante a vigência da sua apólice, inclusive em caso de sinistros."
      }
    ],
    tip: "Ao contratar seu seguro auto, considere seu perfil de uso do veículo para escolher as coberturas mais adequadas. Se você utiliza muito o carro no dia a dia, priorize coberturas mais abrangentes. Se usa pouco, pode optar por coberturas mais básicas e economizar no prêmio."
  };

  return <ServiceTemplate {...serviceData} />;
};

export default AutoInsurance;